export { default as HomeHero } from './Hero';
